import { type CustomTooltipProps } from "ag-grid-react"

import { settingSourceText } from "~/components/prototype/allocation-planning/replenishment/lineSettingsText"
import type { QtyField } from "~/utils/allocationLineSettings"
import { api } from "~/utils/api"
import HeaderTooltip from "./HeaderTooltip"
import TooltipMessageCard from "./TooltipMessageCard"

export type LineSettingSourceTooltipValue = {
  tooltipType: "LineSettingSource"
  lineId: string
  field: QtyField
}

function SettingSource({ lineId, field }: Pick<LineSettingSourceTooltipValue, "lineId" | "field">) {
  const query = api.allocation.getLineRunDetails.useQuery(
    { lineId },
    { select: (details) => details.settings },
  )
  if (query.isPending) return <TooltipMessageCard>Loading where it comes from…</TooltipMessageCard>
  if (query.isError)
    return <TooltipMessageCard>{"Couldn't load where it comes from."}</TooltipMessageCard>
  const text = query.data && settingSourceText(field, query.data)
  return (
    <TooltipMessageCard>
      {text ?? "The run did not store where this setting came from."}
    </TooltipMessageCard>
  )
}

export default function LineSettingSourceTooltip(props: CustomTooltipProps) {
  if (props.location === "header") return <HeaderTooltip {...props} />
  const value = props.value as LineSettingSourceTooltipValue | undefined
  if (!value) return null
  return <SettingSource lineId={value.lineId} field={value.field} />
}
